import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { TelegramWebappService } from '@zakarliuka/ng-telegram-webapp';
import { AuthService } from '../auth.service';

export const TelegramAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const telegramService = inject(TelegramWebappService);
    const authService = inject(AuthService);
    authService.isWebapp = !!telegramService.initDataUnsafe?.user;

    if (!authService.isWebapp) {
        return of(true);
    }
    const params = new URLSearchParams(telegramService.initData);
    const result: Record<string, string> = {};

    params.forEach((value, key) => {
        result[key] = value;
    });
    result['id'] = telegramService.initDataUnsafe?.user?.id + '';
    telegramService.expand();
    return authService
        .signInUsingTelegramAuth(result as any)
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );

}
